import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, ButtonGroup, Form, Spinner } from "react-bootstrap";
import { createWorker } from "tesseract.js";
import { PDFDocument } from "pdf-lib";
import * as pdfjsLib from "pdfjs-dist";

import { distance } from "fastest-levenshtein";

import pdfWorker from "pdfjs-dist/build/pdf.worker.min.mjs?url";
import { api, httpPost } from "./pureFunctions";
import { header, host } from "./globalVariables";
import { useConfig } from "./ConfigContext";
import { changeoOEstate } from "./networkFunctions";
import { useM365Context } from "./m365Context";
import { useAuth } from "./AuthContext";

// const scale = 1;
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

const redactPadding = { x: 14, y: 12 };
// Default für die einstellbare Mindest-Erkennungssicherheit (siehe minOcrConfidence-State unten):
// Tabellenlinien/-rahmen werden von Tesseract manchmal als "Wörter" ohne echten Text erkannt.
// Solche Treffer werden anhand dieser Konfidenz-Schwelle aussortiert, bevor sie als
// Schwärz-Overlay angezeigt werden.
const DEFAULT_MIN_OCR_CONFIDENCE = 60;

export default function OfflineRedact({}) {
   const { user, setUser } = useAuth();

   const config = useConfig();
   const itemRef = useRef();
   const [loading, setLoading] = useState(false);
   const [progress, setProgress] = useState(0);
   const [file, setFile] = useState();
   const [kachelFiles, setKachelFiles] = useState();
   const [imageFiles, setImageFiles] = useState();
   const [scale, setScale] = useState(4);
   const [minOcrConfidence, setMinOcrConfidence] = useState(DEFAULT_MIN_OCR_CONFIDENCE);
   //    const [dict, setDict] = useState("Sandra Baur");
   const [ocrData, setOcrData] = useState([]);
   const [imagePreview, setImagePreview] = useState(null);
   const [docCanvas, setDocCanvas] = useState();
   const [estateId, setEstateId] = useState();
   const [currentPage, setCurrentPage] = useState();
   const [redactAreas, setRedactAreas] = useState([]);
   const [rotationAngles, setRotationAngles] = useState([]);
   const originalCanvasesRef = useRef([]);
   const [selection, setSelection] = useState();
   const [fileName, setFileName] = useState("");
   const [sharepointFileData, setSharepointFileData] = useState();
   const [promptSettings, setPromptSettings] = useState({
      model: "claude-sonnet-4-6",
      creativity: 0,
      maxToken: 1000,
      prompt: ``,
   }); // Singles Kapitalanleger

   const [sharepointFiles, setSharepointFiles] = useState([]);

   const [inputValue, setInputValue] = useState("");
   const [items, setItems] = useState([]);
   const pdfRef = useRef([]);

   const { getSharepointData, getSharepointFile, uploadFileToSharepoint } = useM365Context();

   useEffect(() => {
      itemRef.current = items;
   }, [items]);

   // Bereits erkannte Seiten sofort neu filtern, wenn die Mindest-Erkennungssicherheit geändert wird,
   // ohne dass die komplette Texterkennung erneut laufen muss.
   useEffect(() => {
      if (ocrData.length) {
         refreshFilter(itemRef.current);
      }
   }, [minOcrConfidence]);

   useEffect(() => {
      let params = new URLSearchParams(document.location.search);
      const estate_id = params.get("estateid");
      const address_id = params.get("ownerid");
      const url_sharepointfile = params.get("sharepointfile") && JSON.parse(params.get("sharepointfile"));
      if (url_sharepointfile) {
         setFileName(url_sharepointfile.name);
         setSharepointFileData(url_sharepointfile);
      }

      setEstateId(estate_id);

      if (estate_id || address_id) {
         if (url_sharepointfile?.id && url_sharepointfile?.driveId) {
            console.log(url_sharepointfile);

            loadSharepointFile(url_sharepointfile.id, url_sharepointfile.driveId);
         }
         api.post(
            "/api/getPersonalData",
            [
               {
                  estateId: estate_id,
                  addressId: address_id,
                  estateRequest: [
                     "strasse",
                     "ort",
                     "plz",
                     config.estateSonstige.redactList,
                     config.estate.ordnerName,
                     config.estate.sharepointIds,
                     // "hausnummer",
                     //  "land",
                  ],
                  addressRequest: [
                     //  "ind_2346_Feld_adressen58",
                     //   "Anrede-Titel2",
                     //  "Geburtsdatum2",
                     //  "Geburtsdatum",
                     //  "Anrede-Titel",
                     "Strasse",
                     "Plz-Ort",
                     //  "Land",
                     "Vorname",
                     "Name",
                     "Vorname2",
                     "Name2",
                  ],
               },
            ],
            header,
         )
            .then((data) => {
               console.log(data.data);
               getSharepointData(data.data.estate[config.estate.ordnerName]).then((data) => {
                  const sharepointPDFs = data.flatArray.filter(
                     (fileItem) => fileItem.file && fileItem.file.mimeType === "application/pdf",
                  );
                  console.log(sharepointPDFs);

                  setSharepointFiles(sharepointPDFs);
               });

               let manualDict = data?.data?.estate[config.estateSonstige.redactList]
                  ? JSON.parse(data.data.estate[config.estateSonstige.redactList])
                  : [];

               setKachelFiles(
                  data?.data?.estate[config.estate.sharepointIds]
                     ? JSON.parse(data.data.estate[config.estate.sharepointIds])
                     : [],
               );

               delete data.data.estate[config.estateSonstige.redactList];
               delete data.data.estate[config.estate.sharepointIds];

               let initialDict = Object.values(data.data)
                  .map((item) => Object.values(item))
                  .flat()
                  .filter((item) => item.length > 1);

               console.log(initialDict);
               setItems([...new Set([...initialDict, ...manualDict])]);
            })
            .catch((err) => {
               console.log(err);
            });
      }
   }, []);

   async function loadSharepointFile(fileId, driveId) {
      setLoading(true);
      const fileData = await getSharepointFile(fileId, driveId);
      console.log(fileData);
      let imgFiles =
         fileData &&
         (await convertPdfToImage(fileData).catch((err) => {
            console.log(err);
            setLoading("Error");
         }));
      imgFiles && setRedactAreas(Array.from({ length: imgFiles.length }, () => []));
      imgFiles && setRotationAngles(Array.from({ length: imgFiles.length }, () => 0));
      setImageFiles(imgFiles);
   }

   // Diese Funktion führt die Schwärzung auf dem Canvas durch
   const applyRedaction = (canvas, rects) => {
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "black";

      rects.forEach((rect) => {
         // Wir zeichnen schwarze Rechtecke direkt in die Pixel des Canvas
         ctx.fillRect(
            rect.x0 - redactPadding.x / 2,
            rect.y0 - redactPadding.y / 2,
            rect.x1 - rect.x0 + redactPadding.x,
            rect.y1 - rect.y0 + redactPadding.y,
         );
      });
   };

   async function changeEstateField(myEstateId, data) {
      await changeoOEstate(
         "/api/updateSpecificEstateField",
         {
            estateId: myEstateId,
            oOdata: data, //{ [oOFieldname]: JSON.stringify(mydata) },
         },
         setLoading,
      );
   }

   const downloadAsPDF = async (canvase) => {
      const pdfDoc = await PDFDocument.create();

      for (let i = 0; i < canvase.length; i++) {
         const rects = [
            ...redactAreas[i],
            ...ocrData[i].blocks
               .filter((word) => (word.activePrio != undefined ? word.activePrio : word.active))
               .map((word) => word.bbox),
         ];
         applyRedaction(canvase[i], rects);
         // Für das finale PDF das Canvas verkleinern
         const finalCanvas = document.createElement("canvas");
         // finalCanvas.width = ( canvas.width) / scale;
         // finalCanvas.height = ( canvas.height) / scale;

         finalCanvas.width = canvase[i].width;
         finalCanvas.height = canvase[i].height;
         const fCtx = finalCanvas.getContext("2d");
         fCtx.drawImage(canvase[i], 0, 0, finalCanvas.width, finalCanvas.height);

         // 1. Das geschwärzte Bild vom Canvas als Data-URL extrahieren
         //   const imageData = finalCanvas.toDataURL("image/png");
         const imageData = finalCanvas.toDataURL("image/jpeg", 0.5);

         // 2. Ein neues PDF-Dokument mit pdf-lib erstellen

         // 3. Das Bild (PNG) in das PDF-Dokument einbetten
         //   const pngImage = await pdfDoc.embedPng(imageData);
         const pageImage = await pdfDoc.embedJpg(imageData);

         // 4. Eine Seite in der exakten Größe des Bildes hinzufügen
         const page = pdfDoc.addPage([pageImage.width, pageImage.height]);

         // 5. Das Bild auf die Seite zeichnen
         page.drawImage(pageImage, {
            x: 0,
            y: 0,
            width: pageImage.width,
            height: pageImage.height,
         });
      }

      // 6. Das PDF als Byte-Array generieren
      const pdfBytes = await pdfDoc.save();
      return pdfBytes;
   };

   const triggerDownload = (bytes, fileName) => {
      const blob = new Blob([bytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();

      // Speicher wieder freigeben
      setTimeout(() => URL.revokeObjectURL(link.href), 100);
   };

   async function convertPdfToImage(file) {
      setLoading(true);
      // 1. PDF laden
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;
      console.log("einlesen1");

      const images = [];
      const canvase = [];

      console.log(pdf.numPages);

      for (let i = 1; i <= pdf.numPages; i++) {
         setCurrentPage(i);
         const page = await pdf.getPage(i);
         console.log("pdfseite lesen");

         // 3. Skalierung festlegen (Höherer Wert = bessere Bildqualität)
         const viewport = page.getViewport({ scale });
         // 4. Ein unsichtbares Canvas-Element erstellen
         const canvas = document.createElement("canvas");
         const context = canvas.getContext("2d");
         //   context.rotate((90 * Math.PI) / 180)
         canvas.height = viewport.height;
         canvas.width = viewport.width;

         // 5. Die PDF-Seite in das Canvas zeichnen ("rendern")
         const renderContext = {
            canvasContext: context,
            viewport: viewport,
         };

         await page.render(renderContext).promise;
         console.log("einlesen render1");

         // 6. Das Canvas als Bild-URL (Base64 PNG) exportieren
         //  const imageUrl = canvas.toDataURL("image/jpg", 0.5);
         //   const imageUrl = canvas.toDataURL("image/png");
         images.push({
            page: i,
            dataUrl: canvas.toDataURL("image/png"),
            // dataUrl: canvas.toDataURL("image/jpeg", 0.5),
            width: canvas.width,
            height: canvas.height,
         });

         canvase.push(canvas);
      }

      setDocCanvas(canvase);
      // Unveränderte Original-Canvases separat merken: Rotationen werden immer von hier aus
      // neu berechnet, damit sich kleine Winkelkorrekturen nicht durch mehrfaches Neuzeichnen
      // aufsummieren und das Bild dadurch zunehmend unscharf wird.
      originalCanvasesRef.current = canvase;
      setLoading(false);

      return images; // Diese URL kannst du in einem <img> Tag anzeigen
   }

   // Dreht das Canvas einer einzelnen Seite um die angegebenen Grad (positiv = rechts/im Uhrzeigersinn).
   // Die Zielgröße wird als Bounding-Box des gedrehten Rechtecks berechnet, damit bei jedem Winkel
   // (auch 90°) die komplette Seite sichtbar bleibt und nichts abgeschnitten wird.
   const rotateCanvasByDegrees = (originalCanvas, degrees) => {
      const radians = (degrees * Math.PI) / 180;
      const cos = Math.abs(Math.cos(radians));
      const sin = Math.abs(Math.sin(radians));

      const rotatedCanvas = document.createElement("canvas");
      const ctx = rotatedCanvas.getContext("2d");

      rotatedCanvas.width = Math.ceil(originalCanvas.width * cos + originalCanvas.height * sin);
      rotatedCanvas.height = Math.ceil(originalCanvas.width * sin + originalCanvas.height * cos);

      ctx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
      ctx.rotate(radians);
      ctx.drawImage(originalCanvas, -originalCanvas.width / 2, -originalCanvas.height / 2);

      return rotatedCanvas;
   };

   function refreshFilter(dict) {
      if (estateId && JSON.stringify(dict) !== JSON.stringify(items)) {
         changeEstateField(estateId, { [config.estateSonstige.redactList]: JSON.stringify(dict) });
      }

      if (ocrData.length) {
         let ocrPageData = structuredClone(ocrData);

         for (let i = 0; i < ocrPageData.length; i++) {
            let docContent = filterWords(ocrPageData[i].lines, dict);
            console.log(docContent);

            ocrPageData[i].blocks = docContent;
         }
         setOcrData(ocrPageData);
      }
      setItems(dict);
   }

   function filterWords(lines, dict) {
      const ibanRegex = /\b[A-Z]{2}[0-9]{2}(?:[ ]?[A-Z0-9]{4}){3,7}(?:[ ]?[A-Z0-9]{1,4})?\b/g;
      const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi;
      const regexs = [ibanRegex, emailRegex];
      let dictionaryArray = dict.map((item) => item.toLowerCase().replace(/[,]/g, ""));
      console.log(lines);
      const Lines = lines.map((line) => {
         let allResults = [];

         let hits = regexs
            .map((regexIte) => {
               return validateRegex(line.text, regexIte).map((hit) => hit.toLowerCase());
            })
            .flat();

         let newWords;

         const combinedArray = [...dictionaryArray, ...hits];

         combinedArray.forEach((hitword) => {
            if (hitword.includes(" ")) {
               //    console.log(hitword);

               const lineResult = findPhraseBoxes(line, hitword);
               allResults.push(...lineResult);
            }
         });

         newWords = line.words
            // Tabellenlinien/-rahmen ohne echten Textinhalt bzw. mit sehr niedriger
            // Erkennungssicherheit ausschließen, damit sie nicht als Schwärz-Overlay auftauchen.
            .filter((word) => /[\p{L}\p{N}]/u.test(word.text) && (word.confidence ?? 100) >= minOcrConfidence)
            .map((word) => {
               word.active = combinedArray
                  .filter((hitword) => !hitword.includes(" "))
                  .includes(word.text.toLowerCase().replace(/[,]/g, ""));
               return word;
            });

         return { ...line, words: newWords ? [...newWords, ...allResults] : [...line.words, ...allResults] };
      });

      const docContent = Lines.flatMap((lines) => lines.words);
      return docContent;
   }

   function findPhraseBoxes(line, targetPhrase) {
      const phrase = targetPhrase.toLowerCase();
      const results = [];

      //   data.lines.forEach((line) => {
      const lineText = line.text.toLowerCase();

      if (lineText.includes(phrase)) {
         // Wir finden heraus, welche Wörter der Zeile zur Phrase gehören
         const wordsInLine = line.words;
         const phraseParts = phrase.split(" ");

         for (let i = 0; i <= wordsInLine.length - phraseParts.length; i++) {
            // Prüfen, ob die Sequenz der Wörter übereinstimmt
            let match = true;
            for (let j = 0; j < phraseParts.length; j++) {
               if (!wordsInLine[i + j].text.toLowerCase().includes(phraseParts[j])) {
                  match = false;
                  break;
               }
            }

            if (match) {
               // Boxen der beteiligten Wörter kombinieren
               const matchingWords = wordsInLine.slice(i, i + phraseParts.length);
               const combinedBox = {
                  x0: Math.min(...matchingWords.map((w) => w.bbox.x0)),
                  y0: Math.min(...matchingWords.map((w) => w.bbox.y0)),
                  x1: Math.max(...matchingWords.map((w) => w.bbox.x1)),
                  y1: Math.max(...matchingWords.map((w) => w.bbox.y1)),
               };

               results.push({
                  text: matchingWords.map((w) => w.text).join(" "),
                  bbox: combinedBox,
                  active: true,
               });
            }
         }
      }
      //   });
      return results;
   }

   const doOCR = async (files) => {
      setLoading(true);
      setOcrData([]);
      setProgress(0);

      // 1. Worker initialisieren
      const worker = await createWorker("deu", 1, {
         logger: (m) => {
            if (m.status === "recognizing text") {
               setProgress(Math.round(m.progress * 100));
            }
         },
      });
      await worker.setParameters({
         //  tessedit_pageseg_mode: "6", // Assume a single uniform block of text
         //  tessedit_pageseg_mode: "5", // Assume a single column of text of variable sizes
         tessedit_pageseg_mode: "3", // Automatische Segmentierung
      });

      try {
         for (let i = 0; i < files.length; i++) {
            setCurrentPage(i + 1);

            // 2. Bild verarbeiten
            const { data } = await worker.recognize(files[i].dataUrl, {}, { blocks: true, words: true });
            // console.log(data);
            let lines = data.blocks.flatMap((block) => block.paragraphs).flatMap((para) => para.lines);

            let docContent = filterWords(lines, itemRef.current);
            // console.log(docContent);
            console.log(itemRef.current);

            setOcrData((prev) => [
               ...prev,
               {
                  page: i,
                  fullText: data.text,
                  lines: lines,
                  blocks: docContent,
               },
            ]);

            // getPII(data.text);
         }
         // 3. Ergebnisse speichern (Text + Wort-Koordinaten)
         //  console.log(ocrPageData);

         //  setOcrData(ocrPageData);
      } catch (err) {
         console.error("OCR Fehler:", err);
      } finally {
         await worker.terminate();
         setLoading(false);
      }
   };

   // Führt die OCR nur für eine einzelne Seite erneut aus (nach einer Rotation),
   // ohne die bereits erkannten Daten der anderen Seiten anzutasten.
   const redoOCRForPage = async (pageIndex, dataUrl) => {
      setLoading(true);
      setProgress(0);
      setCurrentPage(pageIndex + 1);

      const worker = await createWorker("deu", 1, {
         logger: (m) => {
            if (m.status === "recognizing text") {
               setProgress(Math.round(m.progress * 100));
            }
         },
      });
      await worker.setParameters({
         tessedit_pageseg_mode: "3",
      });

      try {
         const { data } = await worker.recognize(dataUrl, {}, { blocks: true, words: true });
         let lines = data.blocks.flatMap((block) => block.paragraphs).flatMap((para) => para.lines);
         let docContent = filterWords(lines, itemRef.current);

         setOcrData((prev) => {
            const next = structuredClone(prev);
            next[pageIndex] = { page: pageIndex, fullText: data.text, lines, blocks: docContent };
            return next;
         });
      } catch (err) {
         console.error("OCR Fehler:", err);
      } finally {
         await worker.terminate();
         setLoading(false);
      }
   };

   // Dreht eine einzelne Seite (Canvas + Vorschau) und verwirft ihre alten Schwärzungen/OCR-Boxen
   // (deren Position nach der Drehung nicht mehr passen würde). Die OCR läuft hier noch NICHT neu –
   // dafür klickt man nach dem Zurechtdrehen auf "Fertig" (finalizeRotation).
   // Wichtig: Es wird immer der komplette Winkel auf das unveränderte Original-Canvas angewendet
   // (nicht Schritt für Schritt auf das bereits gedrehte Bild) – sonst würde jede weitere Drehung
   // erneut interpolieren und das Bild mit jedem Klick unschärfer machen.
   const rotatePage = (pageIndex, delta) => {
      const newAngle = ((((rotationAngles[pageIndex] || 0) + delta) % 360) + 360) % 360;
      const rotatedCanvas = rotateCanvasByDegrees(originalCanvasesRef.current[pageIndex], newAngle);
      const dataUrl = rotatedCanvas.toDataURL("image/png");

      const newRotationAngles = [...rotationAngles];
      newRotationAngles[pageIndex] = newAngle;
      setRotationAngles(newRotationAngles);

      const newDocCanvas = [...docCanvas];
      newDocCanvas[pageIndex] = rotatedCanvas;
      setDocCanvas(newDocCanvas);

      const newImageFiles = [...imageFiles];
      newImageFiles[pageIndex] = {
         ...newImageFiles[pageIndex],
         dataUrl,
         width: rotatedCanvas.width,
         height: rotatedCanvas.height,
      };
      setImageFiles(newImageFiles);

      const newRedactAreas = [...redactAreas];
      newRedactAreas[pageIndex] = [];
      setRedactAreas(newRedactAreas);

      setOcrData((prev) => {
         const next = structuredClone(prev);
         next[pageIndex] = { page: pageIndex, fullText: "", lines: [], blocks: [] };
         return next;
      });
   };

   // Wird über den "Fertig"-Button ausgelöst, nachdem eine Seite (ggf. mehrfach) gedreht wurde:
   // stößt die OCR-Erkennung für genau diese Seite mit dem aktuellen (gedrehten) Bild an.
   const finalizeRotation = (pageIndex) => {
      redoOCRForPage(pageIndex, imageFiles[pageIndex].dataUrl);
   };

   function validateRegex(text, regex) {
      const matches = text.matchAll(regex);
      const results = [];

      for (const match of matches) {
         const rawData = match[0];
         // Die IBAN säubern: Leerzeichen entfernen und alles groß schreiben
         //  const cleanIban = rawIban.replace(/\s+/g, "").toUpperCase();
         results.push(rawData);
      }
      return results;
   }

   const getRelativeCoords = (event, pageIndex) => {
      const rect = pdfRef.current[pageIndex].getBoundingClientRect();
      return {
         x: event.clientX - rect.left,
         y: event.clientY - rect.top,
      };
   };

   async function getPII(fullText) {
      let finalPrompt = fullText.replace(/\r\n|\n|\r/g, " ");
      // let finalPrompt = promptSettings.prompt + fullText;
      console.log(fullText);
      console.log(finalPrompt);

      await api
         .post("api/redactPII", { prompt: finalPrompt, promptSettings: promptSettings }, header)
         .then((data) => {
            console.log(data);
            let claudeItems = [];
            try {
               claudeItems = JSON.parse(data.data.replace(/```json|```/g, "").trim());
               console.log(claudeItems);

               claudeItems = claudeItems.pii;
            } catch (error) {
               console.log(error);
            }
            console.log(claudeItems);

            // setItems((prev) => [...new Set([...prev, ...data.data.text.split(",")])]);
            refreshFilter([...new Set([...itemRef.current, ...claudeItems])]);
         })
         .catch((err) => {
            console.log(err);
            setLoading("Error");
         });

      setLoading("");
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      // Nur hinzufügen, wenn das Feld nicht leer ist (ohne Leerzeichen)
      if (inputValue.trim() !== "") {
         let newItems = [...new Set([...items, inputValue.trim()])];

         refreshFilter(newItems);
         setInputValue(""); // Input-Feld leeren
      }
   };

   return (
      <div className="m-5">
         <h2>Datei-Schwärzen</h2>
         {config?.ms365?.active ? (
            <>
               {/* <div>
                  <h5 className="mt-4">Vorhandene Sharepoint PDF auswählen</h5>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                     {sharepointFiles &&
                        sharepointFiles.map((spFile) => {
                           return (
                              <div
                                 title={spFile.name}
                                 style={{
                                    position: "relative",
                                    color: "#333",
                                    background: "#fff",
                                    border: "solid 4px #ddd",
                                    borderRadius: 12,
                                    margin: 4,
                                    padding: 8,
                                    display: "flex",
                                    flexDirection: "column",
                                    textAlign: "center",
                                    width: 180,
                                    overflow: "hidden",
                                    textWrap: "nowrap",
                                    cursor: "pointer",
                                    opacity: loading ? 0.5 : 1,
                                    pointerEvents: loading ? "none" : "all",
                                 }}
                                 onClick={async () => {
                                    setFileName(spFile.name);
                                    setSharepointFileData(spFile);
                                    loadSharepointFile(spFile.id, spFile.parentReference.driveId);
                                 }}
                              >
                                 <div>
                                    <img src={spFile.thumbnails[0].small.url} width={96} height={96} />
                                 </div>
                                 <strong>{spFile.name}</strong>
                                 {loading && (
                                    <div style={{ position: "absolute", width: 160, padding: 10, textAlign: "center" }}>
                                       <Spinner></Spinner>
                                    </div>
                                 )}
                              </div>
                           );
                        })}
                  </div>
               </div> */}
               <h5 className="mt-5">lokale Datei auswählen</h5>
            </>
         ) : (
            <h5 className="mt-3"> Datei auswählen</h5>
         )}

         <input
            type="file"
            className="mt-2"
            onChange={async (e) => {
               setFile(e.target.files[0]);
               setFileName(e.target.files[0].name);
               /* let imgFiles = await convertPdfToImage(e.target.files[0]);
               setRedactAreas(Array.from({ length: imgFiles.length }, () => []));
               setImageFiles(imgFiles); */
            }}
            accept=".pdf"
            style={{ border: "solid 1px #0003", borderRadius: "10px", padding: "0px" }}
            // accept="image/*,.pdf"
         />

         <Form.Group className="mt-3" style={{ maxWidth: 400 }}>
            <Form.Label>Texterkennungssicherheit: {minOcrConfidence}%</Form.Label>
            <Form.Range
               min={0}
               max={100}
               value={minOcrConfidence}
               onChange={(e) => setMinOcrConfidence(Number(e.target.value))}
            />
            <Form.Text muted>
               Je höher der Wert, desto weniger (falsche) Texte werden erkannt. Erhöhen kann zB bei Tabellen hilfreich
               sein, wenn dort Tabellenrahmen als fälschlicherweise als Zeichen erkannt werden.
            </Form.Text>
         </Form.Group>

         <div className="mt-4">
            {/* Qualität der Texterkennung:
            <ButtonGroup className="mx-2">
               {[1, 2, 3, 4].map((scaleFactor) => (
                  <Button
                     variant="btn-dark"
                     className={scale === scaleFactor ? "btn-warning" : "btn-outline-warning"}
                     onClick={() => setScale(scaleFactor)}
                  >
                     {scaleFactor}
                  </Button>
               ))}
            </ButtonGroup> */}
            {file && (
               <Button
                  className="px-5 py-2"
                  disabled={loading}
                  onClick={async () => {
                     let imgFiles = await convertPdfToImage(file);
                     setRedactAreas(Array.from({ length: imgFiles.length }, () => []));
                     setRotationAngles(Array.from({ length: imgFiles.length }, () => 0));
                     setImageFiles(imgFiles);
                  }}
               >
                  {loading && <Spinner size="sm"></Spinner>} {imageFiles ? "Scannen" : "Hochladen"}
               </Button>
            )}
         </div>
         <Form className="mt-4" onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
               <Form.Label>Filterwort hinzufügen (Eingabe/Enter drücken)</Form.Label>
               <Form.Control
                  type="text"
                  placeholder="Schreibe etwas..."
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
               />
            </Form.Group>
         </Form>
         {items &&
            items.map((word) => {
               return (
                  <Button
                     onClick={() => {
                        let newItems = items.filter((ite) => ite != word);
                        refreshFilter(newItems);
                     }}
                     className="me-1 mb-1 btn-dark"
                  >
                     {word} &times;
                  </Button>
               );
            })}

         {loading && imageFiles && (
            <div className="mt-3">
               <p>
                  Analyse Seite {currentPage}/{imageFiles.length}, Fortschritt: {progress}%
               </p>
               <div style={{ width: "100%", bg: "#eee", height: "10px" }}>
                  <div style={{ width: `${progress}%`, background: "#0009", height: "100%" }} />
               </div>
            </div>
         )}

         {imageFiles && imageFiles.length > 0 && (
            <div
               style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "20px",
                  gap: "20px",
                  background: "#222",
                  padding: "20px",
                  borderRadius: "16px",
               }}
            >
               <Alert className="w-100">
                  <h4>Anleitung</h4>
                  Seiten bei Bedarf zuerst zurechtdrehen, dann <strong>Texterkennung starten</strong> klicken. Danach
                  werden <strong>IBAN</strong> und <strong>E-Mailadressen</strong> automatisch geschwärzt.
                  <div>
                     Manuelles Schwärzen:
                     <ul style={{ listStyle: "none", margin: 0 }}>
                        <li>
                           Bereich markieren: Startpunkt: <strong> STRG + Klick </strong> ... Endpunkt:{" "}
                           <strong> Klick </strong>
                        </li>
                        <li>
                           Wort zur Liste hinzufügen und im gesamten Dokument schwärzen:{" "}
                           <strong>Umschalt + Klick</strong> <small>(Umschalt ist Pfeil nach oben über Strg)</small>
                        </li>
                        <li>
                           Einzelnes Wort schwärzen oder Schwärzung wieder entfernen: <strong>Klick</strong>{" "}
                           <small>(Überschreibt das automatische Filtern und wird hier blau markiert)</small>
                        </li>
                     </ul>
                  </div>
               </Alert>

               <Button className="py-3 px-5" disabled={loading} onClick={() => doOCR(imageFiles)}>
                  {loading && <Spinner size="sm"></Spinner>} Texterkennung starten
               </Button>

               {false && (
                  <Button
                     className="py-3 px-5"
                     disabled={loading}
                     onClick={() => {
                        let fullDocText = ocrData.reduce((prevData, newData) => prevData + newData.fullText, "");
                        console.log(fullDocText);

                        getPII(fullDocText);
                     }}
                  >
                     {loading && <Spinner size="sm"></Spinner>} KI-Text-Analyse starten
                  </Button>
               )}
               {imageFiles &&
                  imageFiles.map((imageFile, pageIndex) => {
                     return (
                        <div
                           key={pageIndex}
                           style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "8px",
                              // border: "solid 4px #666",
                              boxShadow: "0 0 10px #cccc",
                              borderRadius: "20px",
                              padding: "20px",
                           }}
                        >
                           <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "8px" }}>
                              <ButtonGroup>
                                 <Button
                                    variant="light"
                                    disabled={loading}
                                    title="90° nach links drehen"
                                    onClick={() => rotatePage(pageIndex, -90)}
                                 >
                                    ⟲ 90°
                                 </Button>
                                 <Button
                                    variant="light"
                                    disabled={loading}
                                    title="0,1° nach links drehen"
                                    onClick={() => rotatePage(pageIndex, -0.1)}
                                 >
                                    ⟲ 0,1°
                                 </Button>
                                 <Button
                                    variant="light"
                                    disabled={loading}
                                    title="0,1° nach rechts drehen"
                                    onClick={() => rotatePage(pageIndex, 0.1)}
                                 >
                                    ⟳ 0,1°
                                 </Button>
                                 <Button
                                    variant="light"
                                    disabled={loading}
                                    title="90° nach rechts drehen"
                                    onClick={() => rotatePage(pageIndex, 90)}
                                 >
                                    ⟳ 90°
                                 </Button>
                              </ButtonGroup>
                              <Button
                                 variant="success"
                                 disabled={loading}
                                 title="Drehung übernehmen und Seite neu erkennen"
                                 onClick={() => finalizeRotation(pageIndex)}
                              >
                                 Fertig
                              </Button>
                           </div>
                           <div style={{ position: "relative", outlineOffset: "-4px", outline: "4px dashed #fff6" }}>
                              <img
                                 src={imageFile.dataUrl}
                                 alt="Preview"
                                 style={{ width: (2 * imageFile.width) / scale }}
                                 ref={(element) => (pdfRef.current[pageIndex] = element)}
                                 onMouseMove={(e) => {
                                    if (selection) {
                                       const { x, y } = getRelativeCoords(e, pageIndex);
                                       let coords = structuredClone(selection);
                                       coords.x1 = x;
                                       coords.y1 = y;
                                       setSelection(coords);
                                    }
                                 }}
                                 onMouseDown={(e) => {
                                    if (selection) {
                                       let newRect = {
                                          x0: (selection.x0 * scale) / 2,
                                          y0: (selection.y0 * scale) / 2,
                                          x1: (selection.x1 * scale) / 2,
                                          y1: (selection.y1 * scale) / 2,
                                       };
                                       let prevRedactAreas = structuredClone(redactAreas);
                                       prevRedactAreas[pageIndex] = [...prevRedactAreas[pageIndex], newRect];
                                       console.log(prevRedactAreas);

                                       setRedactAreas(prevRedactAreas);
                                       setSelection();
                                    } else if (e.ctrlKey) {
                                       console.log(e);
                                       const element = pdfRef.current[pageIndex];
                                       if (!element) return;

                                       const { x, y } = getRelativeCoords(e, pageIndex);
                                       if (!selection) {
                                          setSelection({ x0: x, y0: y, x1: x + 1, y1: y + 1 });
                                       }
                                    }
                                 }}
                              />
                              {selection && selection.y1 && (
                                 <div
                                    className="redact-block"
                                    style={{
                                       width: selection.x1 - selection.x0 + redactPadding.x,
                                       height: selection.y1 - selection.y0 + redactPadding.y,
                                       top: selection.y0 - redactPadding.y / 2,
                                       left: selection.x0 - redactPadding.x / 2,
                                       pointerEvents: "none",
                                       opacity: 0.3,
                                    }}
                                 ></div>
                              )}
                              {redactAreas &&
                                 redactAreas[pageIndex] &&
                                 redactAreas[pageIndex].map((redArea, index) => {
                                    return (
                                       <div
                                          onClick={() => {
                                             let newRedactAreas = structuredClone(redactAreas);
                                             newRedactAreas[pageIndex].splice(index, 1);
                                             setRedactAreas(newRedactAreas);
                                          }}
                                          className="redact-block"
                                          style={{
                                             width: (2 * (redArea.x1 - redArea.x0)) / scale + redactPadding.x,
                                             height: (2 * (redArea.y1 - redArea.y0)) / scale + redactPadding.y,
                                             top: (2 * redArea.y0) / scale - redactPadding.y / 2,
                                             left: (2 * redArea.x0) / scale - redactPadding.x / 2,
                                          }}
                                       ></div>
                                    );
                                 })}
                              {ocrData.length &&
                                 ocrData[pageIndex]?.blocks?.map((block, index) => {
                                    return (
                                       <div
                                          className={
                                             block.activePrio === undefined
                                                ? block.active
                                                   ? "redact-block"
                                                   : "redact-word"
                                                : block.activePrio
                                                  ? "redact-block"
                                                  : "redact-word"
                                          }
                                          onClick={(e) => {
                                             let newOcrData = structuredClone(ocrData);
                                             console.log(newOcrData[pageIndex].blocks[index].text);

                                             if (e.shiftKey) {
                                                let newDict = [
                                                   ...new Set([...items, newOcrData[pageIndex].blocks[index].text]),
                                                ];
                                                refreshFilter(newDict);
                                             } else {
                                                let prevValue =
                                                   newOcrData[pageIndex].blocks[index].activePrio === undefined
                                                      ? newOcrData[pageIndex].blocks[index].active
                                                      : newOcrData[pageIndex].blocks[index].activePrio;
                                                newOcrData[pageIndex].blocks[index].activePrio = !prevValue;
                                                newOcrData[pageIndex].blocks[index].active = !prevValue;
                                                setOcrData(newOcrData);
                                             }
                                          }}
                                          //   className="redact-block"
                                          style={{
                                             pointerEvents: selection ? "none" : "all",
                                             width: (2 * (block.bbox.x1 - block.bbox.x0)) / scale + redactPadding.x,
                                             height: (2 * (block.bbox.y1 - block.bbox.y0)) / scale + redactPadding.y,
                                             top: (2 * block.bbox.y0) / scale - redactPadding.y / 2,
                                             left: (2 * block.bbox.x0) / scale - redactPadding.x / 2,
                                             userSelect: "none",
                                             outline: block.activePrio != undefined ? "dashed 4px #07f9" : "",
                                          }}
                                       >
                                          {block.text}
                                       </div>
                                    );
                                 })}
                           </div>
                        </div>
                     );
                  })}

               <Button className="py-3 px-5" disabled={loading} onClick={() => doOCR(imageFiles)}>
                  {loading && <Spinner size="sm"></Spinner>} Texterkennung starten
               </Button>
            </div>
         )}
         <div className="mt-3">
            {loading && <Spinner></Spinner>}
            {ocrData.length > 0 && (
               <Button
                  variant="primary"
                  className="me-1"
                  disabled={loading}
                  onClick={async () => {
                     setLoading(true);
                     const blobResponse = await downloadAsPDF(docCanvas);
                     triggerDownload(blobResponse, fileName.replace(".pdf", "") + "_geschwaerzt.pdf");
                     setLoading(false);
                  }}
               >
                  Herunterladen 🡇
               </Button>
            )}

            {sharepointFileData && ocrData.length > 0 && (
               <Button
                  variant="outline-primary"
                  disabled={loading}
                  onClick={async () => {
                     setLoading(true);
                     const blobResponse = await downloadAsPDF(docCanvas);

                     const finalBlob = new Blob([blobResponse], { type: "application/pdf" });
                     const uploadResult = await uploadFileToSharepoint(
                        finalBlob,
                        sharepointFileData.driveId,
                        sharepointFileData.parentId,
                        fileName.replace(".pdf", "") + "_geschwaerzt.pdf",
                     );
                     console.log(uploadResult);
                     console.log(user);

                     let updatedKachelfiles = structuredClone(kachelFiles[sharepointFileData.kachel] ?? []);
                     updatedKachelfiles.push({
                        name: uploadResult.id,
                        timestamp: new Date().toISOString(),
                        user: user.Name,
                        public2: true,
                     });
                     changeEstateField(estateId, {
                        [config.estate.sharepointIds]: JSON.stringify({
                           ...kachelFiles,
                           [sharepointFileData.kachel]: updatedKachelfiles,
                        }),
                     });

                     setLoading(false);
                  }}
               >
                  Upload zu Sharepoint 🡅
               </Button>
            )}
         </div>
      </div>
   );
}

/* 

*/
